import React from 'react';
import { Link } from 'react-router-dom';
import { ImagePlaceholder } from '../ui/ImagePlaceholder';
import { ScrollReveal } from '../ui/ScrollReveal';
export function FounderTeaser() {
  return <section className="py-24 md:py-32 bg-[#FFF8F0]" data-id="element-43">
      <div className="container mx-auto px-4 md:px-8" data-id="element-44">
        <div className="flex flex-col md:flex-row items-center gap-12 md:gap-20 max-w-6xl mx-auto" data-id="element-45">
          <div className="w-full md:w-1/2" data-id="element-46">
            <ScrollReveal direction="right" data-id="element-47">
              <div className="relative p-4" data-id="element-48">
                {/* Striped border accent */}
                <div className="absolute inset-0 border-4 border-[#F8C8DC] rounded-3xl transform -rotate-3" data-id="element-49"></div>
                <div className="absolute inset-0 border-4 border-[#F5D76E] rounded-3xl transform rotate-2 opacity-50" data-id="element-50"></div>
                <ImagePlaceholder label="Founder photo" aspectRatio="portrait" className="relative z-10 shadow-xl" data-id="element-51" />
              </div>
            </ScrollReveal>
          </div>

          <div className="w-full md:w-1/2 flex flex-col items-start text-left" data-id="element-52">
            <ScrollReveal direction="left" delay={200} data-id="element-53">
              <span className="font-body font-bold text-[#E91E8C] uppercase tracking-widest text-sm mb-4 block" data-id="element-54">
                Meet the founder
              </span>
              <h2 className="font-heading text-4xl md:text-5xl font-bold text-[#2D1A1A] mb-6" data-id="element-55">
                Hey, I'm Jess
              </h2>
              <p className="font-body text-lg text-[#2D1A1A] opacity-80 mb-6 leading-relaxed" data-id="element-56">
                I started Butter Blonde because I couldn't find jewelry that
                felt both elevated and effortless. I wanted pieces that I could
                throw on with a t-shirt or a slip dress—pieces that felt
                personal, playful, and totally me.
              </p>
              <p className="font-body text-lg text-[#2D1A1A] opacity-80 mb-8 leading-relaxed" data-id="element-57">
                Every chain, pearl, and charm is designed to be mixed, matched,
                and stacked. There are no rules here.
              </p>
              <Link to="/about" className="inline-flex items-center font-body font-bold text-[#6B1D4A] hover:text-[#E91E8C] transition-colors text-lg group border-b-2 border-[#6B1D4A] hover:border-[#E91E8C] pb-1" data-id="element-58">
                Read My Story
                <span className="ml-2 transform group-hover:translate-x-1 transition-transform" data-id="element-59">
                  →
                </span>
              </Link>
            </ScrollReveal>
          </div>
        </div>
      </div>
    </section>;
}